var FieldDictionary = function FieldDictionary(input) {
  this.id = void 0;
  this.url = void 0;
  this.title = void 0;
  this.subtitle = void 0;
  this.description = void 0;
  this.image = void 0;
  this.createdAt = void 0;
  this.price = void 0;
  this.originalPrice = void 0;
  this.salePrice = void 0;
  this.rating = void 0;
  this.quantity = void 0;

  var _ref = input != null ? input : {},
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '_id' : _ref$id,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? 'url' : _ref$url,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'title' : _ref$title,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? 'url' : _ref$subtitle,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? 'description' : _ref$description,
      _ref$image = _ref.image,
      image = _ref$image === void 0 ? 'image' : _ref$image,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? 'price' : _ref$price,
      _ref$originalPrice = _ref.originalPrice,
      originalPrice = _ref$originalPrice === void 0 ? 'originalPrice' : _ref$originalPrice,
      _ref$salePrice = _ref.salePrice,
      salePrice = _ref$salePrice === void 0 ? 'salePrice' : _ref$salePrice,
      _ref$rating = _ref.rating,
      rating = _ref$rating === void 0 ? 'rating' : _ref$rating,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 'quantity' : _ref$quantity,
      _ref$createdAt = _ref.createdAt,
      createdAt = _ref$createdAt === void 0 ? 'created_at' : _ref$createdAt;

  this.id = id;
  this.url = url;
  this.title = title;
  this.subtitle = subtitle;
  this.description = description;
  this.image = image;
  this.price = price;
  this.originalPrice = originalPrice;
  this.salePrice = salePrice;
  this.rating = rating;
  this.quantity = quantity;
  this.createdAt = createdAt;
};

export { FieldDictionary };
//# sourceMappingURL=types.esm.js.map
